// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__XIhMY","modalFooterButton":"ModalNotes_modalFooterButton__2qItv"};